import { ReportsRow } from '../../../modules/revenueInsightsV2/types'
import { RevenueInsightsDetailsComponent } from './RevenueInsightsDetailsComponent'
import { RevenueInsightsProductComponent } from './RevenueInsightsProductcomponent'
import { useStyles } from './RevenueInsightsCommon.style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCurrentCloudProvider } from '@labrav/common'
import { Divider } from '@mui/material'
import {
  faCalendarCheck,
  faChartLineUp,
  faCreditCard,
  faHandHoldingDollar,
  faMoneyBillWave,
  faPercent,
  faStore,
  faTag,
  faUser,
  faUserFriends,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import {
  awsCollectionItemsToRender,
  awsTaxItemsToRender,
  awsSellerItemsToRender,
  awsPayerItemsToRender,
  azureResellerItemsToRender,
} from './RevenueInsightsComponentMap'
import { getRevenueInsightsItemsByCloud } from './getRevenueInsightsItemsByCloud'
import { getCurrencySymbol } from '../../../common/utils/getCurrencySymbol'

export interface RevenueInsightsProductComponentProps {
  reportData: ReportsRow
}

export const RevenueSidePanelWrapper: React.FC<
  RevenueInsightsProductComponentProps
> = ({ reportData }) => {
  const { classes } = useStyles()
  const getHeaderIcon = (icon: IconDefinition) => {
    return (
      <FontAwesomeIcon icon={icon} border className={classes.magnifyingGlass} />
    )
  }
  const selectedCloudTypeProductListing = useCurrentCloudProvider()
  const buyerItemsToRender = getRevenueInsightsItemsByCloud(
    selectedCloudTypeProductListing,
    'buyer'
  )
  const offerItemsToRender = getRevenueInsightsItemsByCloud(
    selectedCloudTypeProductListing,
    'offer'
  )
  const contractItemsToRender = getRevenueInsightsItemsByCloud(
    selectedCloudTypeProductListing,
    'contract'
  )
  const disbursementItemsToRender = getRevenueInsightsItemsByCloud(
    selectedCloudTypeProductListing,
    'disbursement'
  )
  const revenueItemsToRender = getRevenueInsightsItemsByCloud(
    selectedCloudTypeProductListing,
    'revenue'
  )
  const currencySymbol = getCurrencySymbol(reportData.currency as string)

  return (
    <div>
      <RevenueInsightsProductComponent
        reportRow={reportData}
        currencySymbol={currencySymbol}
      />
      <RevenueInsightsDetailsComponent
        reportRow={reportData}
        rowHeader="Buyer details"
        colsToRender={buyerItemsToRender}
        headerIcon={getHeaderIcon(faUser)}
        currencySymbol={currencySymbol}
      />
      <Divider />
      <RevenueInsightsDetailsComponent
        reportRow={reportData}
        rowHeader="Offer details"
        colsToRender={offerItemsToRender}
        headerIcon={getHeaderIcon(faTag)}
      />
      <Divider />
      <RevenueInsightsDetailsComponent
        reportRow={reportData}
        rowHeader="Contract details"
        colsToRender={contractItemsToRender}
        headerIcon={getHeaderIcon(faCalendarCheck)}
      />
      <Divider />
      <RevenueInsightsDetailsComponent
        reportRow={reportData}
        rowHeader="Disbursement details"
        colsToRender={disbursementItemsToRender}
        headerIcon={getHeaderIcon(faMoneyBillWave)}
      />
      <Divider />

      {selectedCloudTypeProductListing === 'AWS' && (
        <>
          <RevenueInsightsDetailsComponent
            reportRow={reportData}
            rowHeader="Collection details"
            colsToRender={awsCollectionItemsToRender}
            headerIcon={getHeaderIcon(faHandHoldingDollar)}
            currencySymbol={currencySymbol}
          />
          <Divider />
        </>
      )}

      <RevenueInsightsDetailsComponent
        reportRow={reportData}
        rowHeader="Revenue details"
        colsToRender={revenueItemsToRender}
        headerIcon={getHeaderIcon(faChartLineUp)}
        currencySymbol={currencySymbol}
      />
      <Divider />

      {selectedCloudTypeProductListing === 'AWS' && (
        <>
          <RevenueInsightsDetailsComponent
            reportRow={reportData}
            rowHeader="Tax details"
            colsToRender={awsTaxItemsToRender}
            headerIcon={getHeaderIcon(faPercent)}
          />
          <Divider />
          <RevenueInsightsDetailsComponent
            reportRow={reportData}
            rowHeader="Seller details"
            colsToRender={awsSellerItemsToRender}
            headerIcon={getHeaderIcon(faStore)}
          />
          <Divider />
          <RevenueInsightsDetailsComponent
            reportRow={reportData}
            rowHeader="Payer details"
            colsToRender={awsPayerItemsToRender}
            headerIcon={getHeaderIcon(faCreditCard)}
          />
          <Divider />
        </>
      )}

      {selectedCloudTypeProductListing === 'AZURE' && (
        <>
          <RevenueInsightsDetailsComponent
            reportRow={reportData}
            rowHeader="Reseller details"
            colsToRender={azureResellerItemsToRender}
            headerIcon={getHeaderIcon(faUserFriends)}
          />
          <Divider />
        </>
      )}
    </div>
  )
}
